<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_tr14"
      :custom="{ storage: true }"
      :refresh="{ query: RefreshList }"
      export
    >
      <template v-slot:buttons>
        <el-button v-if="transport_search_button" @click="funcFilter"
          >查询</el-button
        >
        <el-button
          v-if="transport_search_button"
          @click="batchInputDialogVisible = true"
          >多运单查询</el-button
        >
        <el-button @click="clearFilterTable">清除筛选条件</el-button>
        <el-button v-if="transport_export_button" @click="funcExport"
          >导出</el-button
        >
        <!-- @focus="batchInputDialogVisible = true" -->
      </template>
    </vxe-toolbar>

    <!-- :row-class-name="rowClassName" -->
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      show-footer
      :footer-method="footerMethod"
      :sort-config="{ remote: true }"
      :row-class-name="rowClassName"
      export-config
      show-overflow
      align="center"
      class="mytable-style"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column v-if="isSub">
        <vxe-table-column
          field="companyName"
          title="子公司名称"
          min-width="200"
          sortable
          fixed="left"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入子公司名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择承运主体"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="210"
          sortable
        >
          <template #default="scope">
            <div class="oeder_num_box">
              {{ scope.row.orderCode }}
              <!-- -->
              <!-- <img
                v-if="scope.row.payType == 1"
                class="icon_yu"
                src="@/assets/icon/yu.png"
                alt=""
              /> -->
              <div v-if="scope.row.payType == 1" class="yu_text">
                预付
              </div>
              <div
                v-if="
                  scope.row.appealStatus == 1 ||
                    scope.row.appealStatus == 2 ||
                    scope.row.appealStatus == 4 ||
                    scope.row.appealStatus == 5
                "
                class="abnormal_text"
              >
                异常
              </div>
            </div>
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入运输单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="sourceOrderNumber"
          title="来源单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.sourceOrderNumber"
            placeholder="请输入来源单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="projectName"
          title="项目名称"
          min-width="200"
          sortable
        >
          <template #default="scope">
            <span
              class="project_name_span"
              @click="copyText(scope.row.projectName)"
              v-html="scope.row.projectName"
            />
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-input
            v-model="listQuery.projectName"
            placeholder="请输入项目名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lineName"
          title="线路简称"
          min-width="200"
          sortable
        >
          <template #default="scope">
            <span
              class="project_name_span"
              @click="copyText(scope.row.lineName)"
              v-html="scope.row.lineName"
            />
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-input
            v-model="listQuery.lineName"
            placeholder="请输入线路简称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人姓名"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="实际承运人电话"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入实际承运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车牌号"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="isReceiptReturn"
          :formatter="formatterStatus"
          title="纸质回单状态"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isReceiptReturn"
            clearable
            placeholder="请选择纸质回单状态"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="运单状态"
          :formatter="formatterStatuss"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.status"
            clearable
            placeholder="请选择运单状态"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 签收状态 -->
      <vxe-table-column>
        <vxe-table-column
          field="isUnloadingConfirm"
          title="签收状态"
          :formatter="formatterUnloadingConfirm"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isUnloadingConfirm"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in uploadingOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 签收end -->
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="paySta"
          title="支付状态"
          :formatter="formatterPayStatus"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.paySta"
            clearable
            placeholder="请选择支付状态"
          >
            <el-option
              v-for="item in payOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="etcType"
          title="ETC推送状态"
          :formatter="formatterETCStatus"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.etcType" clearable placeholder="请选择">
            <el-option
              v-for="item in etcOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipment">
        <vxe-table-column
          field="paySta"
          title="支付状态"
          :formatter="formatterPayStatus"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.paySta"
            clearable
            placeholder="请选择支付状态"
          >
            <el-option
              v-for="item in payOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isCancel"
          title="取消状态"
          min-width="130"
          sortable
        >
          <template #default="{row}">
            <div
              :class="[
                formatterCancel(row) === '正常' ? 'green_text' : 'gray_text'
              ]"
            >
              {{ formatterCancel(row) }}
            </div>
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.isCancel"
            clearable
            placeholder="请选择取消状态"
          >
            <el-option
              v-for="item in cancelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalTypeName"
          title="货物名称"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalTypeName"
            placeholder="请输入货物名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="weight"
          title="接单数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.weightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.weightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadQuantity"
          title="装货数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.loadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.loadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="unloadQuantity"
          title="卸货数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.unloadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.unloadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="wastage"
          title="货物损耗"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.wastageStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.wastageEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="settlementWeight"
          title="结算吨位"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.settlementWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.settlementWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="price"
          title="运费单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.settlementWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.settlementWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="taxFee"
          title="托运人预估运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="prePay"
          title="托运人预付运费(元)"
          min-width="200"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.payAmount }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.prePayStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.prePayEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipperDeliveryFee"
          title="到付款费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipperDeliveryFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipperDeliveryFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentActualCash"
          title="托运人回单付款费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentActualCashStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualCashEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="driftPrice"
          title="浮动费用(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.driftPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.driftPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentDeliveryFeePractical"
          title="托运人应付运费(元)"
          min-width="200"
          :formatter="formatterPrice"
        />
        <template v-slot:header>
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentActualFreight"
          title="托运人实付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentActualFreightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualFreightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentActualCash"
          title="托运人实付现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentActualCashStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualCashEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipperDeliveryFee"
          title="托运人合计付款(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipperDeliveryFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipperDeliveryFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="allTaxFee"
          title="总服务费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPayFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPayFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deliveryFeePractical"
          title="实际承运人净得运费(元)"
          min-width="200"
          :formatter="formatteFeePractical"
        />
        <template v-slot:header>
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfShipment"
          title="装货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfShipment"
            placeholder="请输入装货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadPlace"
          title="实际操作装货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.loadPlace"
            placeholder="请输入实际操作装货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfReceipt"
          title="卸货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfReceipt"
            placeholder="请输入卸货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="unloadPlace"
          title="实际操作卸货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.unloadPlace"
            placeholder="请输入实际操作卸货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalPrice"
          title="货物单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.coalPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.coalPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalName"
          title="运输要求"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalName"
            placeholder="请输入运输要求"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="distance"
          title="里程数(公里)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.distanceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.distanceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="isMonthlyOrder"
          title="结算类型"
          min-width="100"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isMonthlyOrder')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isMonthlyOrder"
            placeholder="请选择结算类型"
            clearable
          >
            <el-option
              v-for="item in parentData.isMonthlyOrderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isTransfer"
          title="是否调单"
          min-width="130"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.isTransfer > 0 ? "是" : "否" }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.isTransferSearch"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in isTransferSearchOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isAdmin">
        <vxe-table-column
          field="reportMark"
          title="是否标记"
          min-width="130"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.reportMark > 0 ? "是" : "否" }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.reportMark"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in isTransferSearchOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="orderGmtCreated"
          title="下单时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.orderGmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'orderGmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="接单时间"
          min-width="420"
          sortable
        />
        <!-- @change="value => changeDate(value, 'gmtCreated')" -->
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreated"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastLoadingTime"
          title="截止装车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastLoadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastLoadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="fillTime"
          title="装车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.fillTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'fillTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastUnloadingTime"
          title="截止卸车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastUnloadingTimeRange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            @change="value => changeDate(value, 'lastUnloadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="signTime"
          title="卸车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.signTimeRange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            @change="value => changeDate(value, 'signTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="settleTime"
          title="核算时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.settleTimeRange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            @change="value => changeDate(value, 'settleTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="payFailReasons"
          title="失败原因"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payFailReasons"
            placeholder="请输入失败原因"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入货源单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="teamName"
          title="车队名称"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.teamName"
            placeholder="请输入车队名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="companyName"
          title="托运人"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入托运人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="dfName"
          title="经办人"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.dfName"
            placeholder="请输入经办人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="ordCreatedByPhone"
          title="托运人电话"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.ordCreatedByPhone"
            placeholder="请输入托运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentStaffTypeStr"
          title="托运人类型"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.shipmentStaffType"
            clearable
            placeholder="请选择托运人类型"
          >
            <el-option
              v-for="item in shipmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="最后操作时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtModifiedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>
      <!-- =========================================================================================================== -->

      <!-- <vxe-table-column v-if="isAdmin && isShowTxStatus == 1">
        <vxe-table-column
          field="txStatus"
          title="上链状态"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'txStatus')
          "
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.txStatus"
            placeholder="请选择上链状态"
            clearable
          >
            <el-option
              v-for="item in parentData.txStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column> -->

      <!-- <vxe-table-column>
        <vxe-table-column
          field="ordCreatedByName"
          title="托运人名称"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.ordCreatedByName"
            placeholder="请输入托运人名称"
            clearable
          />
        </template>
      </vxe-table-column> -->

      <!-- <vxe-table-column>
        <vxe-table-column
          field="maxPrice"
          title="最高价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.maxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.maxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="taxPrice"
          title="托运人成交单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->

      <!-- <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="realPrice"
          title="实际承运人承运单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.realPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.realPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="deliveryFeeDeserved"
          title="实际承运人预估运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryFeeDeservedStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeeDeservedEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="platformPrepayment"
          title="平台预付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.platformPrepaymentStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.platformPrepaymentEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->

      <!-- <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="driverActualFreight"
          title="实际承运人实收运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.driverActualFreightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.driverActualFreightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="driverActualCash"
          title="实际承运人实收现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.driverActualCashStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.driverActualCashEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="deliveryCashFee"
          title="实际承运人合计收款(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryCashFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryCashFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column>
        <vxe-table-column
          field="extraFee"
          title="其他费用(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.extraFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.extraFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->

      <!-- <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="payOil"
          title="平台预付油点(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payOilStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payOilEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="payAmount"
          title="平台预付现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="allotOil"
          title="已分配油费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.allotOilStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.allotOilEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->

      <vxe-table-column v-if="isAdmin">
        <vxe-table-column
          field="modifiedByName"
          title="最后操作人"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="请输入最后操作人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="200" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="transport_detail_button"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
            width="50"
          >
            <vxe-button
              type="text"
              @click="orderDesil(scope.row.code, scope.row)"
              ><em class="el-icon-document"
            /></vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              scope.row.appealStatus == 2 ||
                scope.row.appealStatus == 4 ||
                scope.row.appealStatus == 5 ||
                scope.row.appealStatus == 3
            "
            class="item"
            effect="dark"
            content="申诉详情"
            placement="top"
          >
            <vxe-button type="text" @click="watchAppealOrder(scope.row)">
              <em class="el-icon-files" />
            </vxe-button>
          </el-tooltip>

          <!-- 重推     -->
          <el-tooltip
            v-if="
              getLimit('transport_resend_weighbridge_button') &&
                scope.row.vendorName
            "
            class="item"
            effect="dark"
            content="重推地磅"
            placement="top"
            width="50"
          >
            <vxe-button
              type="text"
              @click="
                pushWaybillToMqttByOrderCodeApi(scope.row.code, scope.row)
              "
            >
              <img
                style="width: 15px; height: 15px;display: inline-block;transform: translateY(3px)"
                src="@/assets/icon/chongtui.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="transport_splitOrder_button && scope.row.isSplitOrder != 0"
            class="item"
            effect="dark"
            content="分单"
            placement="top"
            width="50"
          >
            <vxe-button type="text" @click="splitOrder(scope.row.code)"
              ><em class="el-icon-tickets"
            /></vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="transport_history_button && scope.row.status == 5"
            class="item"
            effect="dark"
            content="打款记录"
            placement="top"
          >
            <vxe-button type="text" @click="moneyHistoury(scope.row.code)"
              ><em class="el-icon-notebook-2"
            /></vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('transport_signplay_button') &&
                scope.row.reportMark == '0' &&
                scope.row.isSend != 1
            "
            class="item"
            effect="dark"
            content="上报标记"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="
                setreportMark(scope.row.reportMarkMsg, scope.row.code, '1')
              "
              ><em class="el-icon-location"
            /></vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('transport_signpause_button') &&
                scope.row.reportMark == '1' &&
                scope.row.isSend != 1
            "
            class="item"
            effect="dark"
            content="取消标记"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="
                setreportMark(scope.row.reportMarkMsg, scope.row.code, '0')
              "
              ><em class="el-icon-location-outline"
            /></vxe-button>
          </el-tooltip>

          <!-- 删除 -->
          <el-tooltip
            v-if="
              getLimit('waybillManage_wait_del_button') &&
                isAdmin &&
                scope.row.status < 4 &&
                scope.row.deleted == 0
            "
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="handleDelete(scope.row)">
              <em class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <!-- -->
          <el-tooltip
            v-if="
              scope.row.deleted === 1 && getLimit('waybillManage_reset_button')
            "
            class="item"
            effect="dark"
            content="恢复"
            placement="top"
          >
            <vxe-button type="text" @click="recoverDeletedOrderApi(scope.row)">
              <img
                style="width: 15px; height: 15px;display: inline-block;transform: translateY(3px)"
                src="@/assets/icon/reset.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="tuteship"
      title="运输单详情"
      width="1000"
      height="80%"
      resize
    >
      <ordergoods
        ref="detailRef"
        :order-info="orderInfo"
        @openMap="positionFunc"
      />
    </vxe-modal>
    <vxe-modal
      v-model="splitOrderFlag"
      title="子单详情"
      width="800"
      height="85%"
      resize
    >
      <splitOrder ref="splitOrderRef" />
    </vxe-modal>
    <vxe-modal
      v-model="positionFlag"
      title="运单轨迹"
      width="1000"
      height="800"
      resize
      remember
    >
      <Position
        v-if="positionFlag"
        ref="positionRef"
        :order-code="code4OrderTrack"
        :positoin-info="positoinInfo"
        @fatherCancelMethod="positionFlag = false"
      />
    </vxe-modal>
    <vxe-modal
      v-model="showDelete"
      title="删除"
      width="600"
      height="260"
      resize
      remember
    >
      <div v-if="showDelete" style="margin-top:10px">
        <el-form>
          <el-form-item label="取消原因">
            <el-input v-model="platformCancelReason" type="textarea" :row="3" />
          </el-form-item>
        </el-form>
        <div style="text-align: right;margin-top:10px">
          <el-button type="primary" @click="delFunc">确定</el-button>
        </div>
      </div>
    </vxe-modal>
    <downloadData ref="downloadRef" />
    <fundMoneyHistory ref="HistoryRef" :parent-data="parentData" />
    <el-dialog
      title="批量输入运单号"
      :visible.sync="batchInputDialogVisible"
      width="650px"
      height="900px"
      class="batch-input-dialog"
    >
      <BatchWaybill
        :codes="listQuery.orderCode"
        @confirmBatchInput="confirmBatchInput"
      />
    </el-dialog>
    <vxe-modal
      v-model="isAppealOrder"
      :title="alertType === 'detail' ? '申诉详情' : '运单申诉'"
      width="850px"
      height="750px"
      resize
      remember
      @close="closePositionFunc"
    >
      <appealOrder
        v-if="isAppealOrder"
        ref="positionRef"
        :appeal-info="appealInfo"
        :alert-type="alertType"
        @close="updateList"
      />
    </vxe-modal>
  </div>
</template>
<script>
import appealOrder from "../../CarrierSettlement/AbnormalWaybill/components/appealOrder.vue";
import BatchWaybill from "@/components/BatchWaybill";
import Position from "@/views/tms/transportManage/waybillManage/components/components/Position";
import { getLimit } from "@/utils/getLimit.js";
import ordergoods from "@/components/WaybillDetails";
import splitOrder from "@/views/tms/order/splitOrder";
import {
  querySubList,
  orderDetailList,
  reportMark,
  isOpenMaYi
} from "@/api/transport";
import {
  deleteDetail,
  recoverDeletedOrder,
  pushWaybillToMqttByOrderCode
} from "@/api/transport";
import fundMoneyHistory from "@/views/tms/carlessCarrierReporting/fundFlowReporting/components/fundMoneyHistory.vue";

/** 与表头筛选项一致，供「清除筛选条件」与路由重置使用（不含分页与排序字段） */
function createClearedListQuery() {
  return {
    lastLoadingTimeRange: "",
    fillTimeRange: "",
    lastUnloadingTimeRange: "",
    signTimeRange: "",
    gmtCreatedRange: "",
    gmtModifiedRange: "",
    orderGmtCreatedRange: "",
    settleTimeRange: "",
    gmtCreated: null,
    orderGmtCreatedStart: "",
    orderGmtCreatedEnd: "",
    gmtCreatedStart: "",
    gmtCreatedEnd: "",
    lastLoadingTimeStart: "",
    lastLoadingTimeEnd: "",
    fillTimeStart: "",
    fillTimeEnd: "",
    lastUnloadingTimeStart: "",
    lastUnloadingTimeEnd: "",
    signTimeStart: "",
    signTimeEnd: "",
    settleTimeStart: "",
    settleTimeEnd: "",
    gmtModifiedStart: "",
    gmtModifiedEnd: "",
    companyName: "",
    branchCode: "",
    orderCode: "",
    sourceOrderNumber: "",
    projectName: "",
    lineName: "",
    driverName: "",
    driverPhone: "",
    vehicleLicense: "",
    isReceiptReturn: null,
    status: null,
    isUnloadingConfirm: null,
    paySta: null,
    etcType: null,
    isCancel: null,
    coalTypeName: "",
    weightStart: "",
    weightEnd: "",
    loadQuantityStart: "",
    loadQuantityEnd: "",
    unloadQuantityStart: "",
    unloadQuantityEnd: "",
    wastageStart: "",
    wastageEnd: "",
    settlementWeightStart: "",
    settlementWeightEnd: "",
    taxFeeStart: "",
    taxFeeEnd: "",
    prePayStart: "",
    prePayEnd: "",
    shipperDeliveryFeeStart: "",
    shipperDeliveryFeeEnd: "",
    shipmentActualCashStart: "",
    shipmentActualCashEnd: "",
    driftPriceStart: "",
    driftPriceEnd: "",
    shipmentDeliveryFeePracticalStart: "",
    shipmentDeliveryFeePracticalEnd: "",
    shipmentActualFreightStart: "",
    shipmentActualFreightEnd: "",
    taxPayFeeStart: "",
    taxPayFeeEnd: "",
    deliveryFeePracticalStart: "",
    deliveryFeePracticalEnd: "",
    placeOfShipment: "",
    loadPlace: "",
    placeOfReceipt: "",
    unloadPlace: "",
    coalPriceStart: "",
    coalPriceEnd: "",
    coalName: "",
    distanceStart: "",
    distanceEnd: "",
    isMonthlyOrder: null,
    isTransferSearch: null,
    reportMark: null,
    payFailReasons: "",
    mainOrderNumber: "",
    teamName: "",
    dfName: "",
    ordCreatedByPhone: "",
    shipmentStaffType: null,
    txStatus: null,
    ordCreatedByName: "",
    maxPriceStart: "",
    maxPriceEnd: "",
    taxPriceStart: "",
    taxPriceEnd: "",
    realPriceStart: "",
    realPriceEnd: "",
    deliveryFeeDeservedStart: "",
    deliveryFeeDeservedEnd: "",
    platformPrepaymentStart: "",
    platformPrepaymentEnd: "",
    driverActualFreightStart: "",
    driverActualFreightEnd: "",
    driverActualCashStart: "",
    driverActualCashEnd: "",
    deliveryCashFeeStart: "",
    deliveryCashFeeEnd: "",
    extraFeeStart: "",
    extraFeeEnd: "",
    payOilStart: "",
    payOilEnd: "",
    modifiedByName: "",
    coalType: ""
  };
}

export default {
  name: "TransportManageParnt",
  components: {
    ordergoods,
    splitOrder,
    fundMoneyHistory,
    Position,
    BatchWaybill,
    appealOrder
  },
  data() {
    return {
      alertType: "",
      isAppealOrder: false,
      appealInfo: null,
      batchInputDialogVisible: false,
      showDelete: false,
      platformCancelReason: "",
      deleteCode: "",
      positionFlag: false,
      code4OrderTrack: "",
      positoinInfo: {},
      uploadingOptions: [
        {
          value: 0,
          label: "未签收"
        },
        {
          value: 1,
          label: "已签收"
        }
      ],
      exportObj: {
        exportUrl: "/ntocc-tms-api/orderDetail/export", //导出接口
        name: "运单管理列表"
      },
      alertValue: "", //取消标记  验证字段
      loading: false,
      tuteship: false,
      tableData: [],
      parentData: {
        isMonthlyOrderOptions: [],
        txStatusOptions: []
      },
      openMaYiBlockChain: false, //是否数据上链
      areaOptions: this.$store.state.components.areaOptions,
      consignorAreaList: [],
      consigneeAreaList: [],
      splitOrderFlag: false,
      transport_search_button: false, //查询
      transport_export_button: false, //导出
      transport_detail_button: false, //详情
      transport_splitOrder_button: false, //分单
      transport_history_button: false, // 打款记录
      partyType: "",
      listQuery: {
        ...createClearedListQuery(),
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
        // deleted: 0
      },
      // Pagingconf: [],
      sumObject: {},
      isAdmin: false,
      isShipment: false,
      isShipmentOrAdmin: false,
      isDriverOrAdmin: false,
      statusOptions: [
        { value: 1, label: "已接单" },
        { value: 2, label: "已装货" },
        { value: 3, label: "已卸货" },
        { value: 4, label: "已核算" },
        { value: 5, label: "部分支付" },
        { value: 6, label: "已打款" }
      ],
      etcOptions: [
        {
          label: "未推送",
          value: 0
        },
        {
          label: "开始推送",
          value: 1
        },
        {
          label: "推送完成",
          value: 2
        }
      ],
      payOptions: [
        {
          label: "未支付",
          value: 0
        },
        {
          label: "已支付",
          value: 1
        }
      ],
      payShipment: [
        {
          label: "未支付",
          value: 0
        },
        {
          label: "已支付",
          value: 1
        },
        {
          label: "已驳回",
          value: 2
        }
      ],
      isTransferSearchOptions: [
        { value: 0, label: "否" },
        { value: 1, label: "是" }
      ],
      shipmentOptions: [
        { label: "个体托运人", value: 0 },
        { label: "企业托运人", value: 1 }
      ],
      options: [
        {
          value: "0",
          label: "未收取"
        },
        {
          value: "1",
          label: "已收取"
        }
      ],
      cancelOptions: [
        {
          label: "正常",
          value: 0,
          color: "gray"
        },
        {
          label: "撤单申请",
          value: 1,
          color: "#0000ff"
        },
        // {
        //   label: "同意撤销",
        //   value: 2,
        //   color: "#ff0000"
        // },
        {
          label: "拒绝撤销",
          value: 3,
          color: "#00bd93"
        },
        {
          label: "已取消",
          value: 4,
          color: "#00bd93"
        }
      ],
      isShowTxStatus: "",
      orderInfo: null
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    },
    isSub() {
      return this.$route.path.includes("sub_Transport");
    }
  },
  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable.updateData();
    },
    $route: {
      handler(newVal) {
        console.log("路由参数newVal=================", newVal);
        if (newVal.query.type === "checkTransport") {
          this.listQuery.isCancel = 0;
          // this.listQuery.gmtCreatedEnd = newVal.query.endTime;
          // 使用 $set 确保响应式更新，确保日期选择器能够正确显示
          if (newVal.query.endTime) {
            // 只保留年月日部分，去除时间部分
            const startTime = newVal.query.startTime.split(" ")[0];
            const endDate = newVal.query.endTime.split(" ")[0];
            this.$set(this.listQuery, "gmtCreatedRange", [startTime, endDate]);
            this.listQuery.gmtCreatedStart = startTime;
            this.listQuery.gmtCreatedEnd = endDate;
          } else {
            this.$set(this.listQuery, "gmtCreatedRange", []);
          }
          this.listQuery.paySta = 0;
          this.findList();
        } else {
          this.listQuery = {
            ...createClearedListQuery(),
            pageNum: 1,
            pageSize: 20,
            sortField: "",
            sortType: "",
            total: 0
          };
          this.findList();
        }
      },
      immediate: true
    }
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isAdmin = isAdmin;
    this.isShipmentOrAdmin =
      partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY" || isAdmin;
    this.isShipment =
      partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY";
    this.isDriverOrAdmin =
      partyType == "DRIVER" || partyType == "DRIVER_LEADER" || isAdmin;
    this.parentData.isMonthlyOrderOptions = [
      { label: "次结", value: 0 },
      { label: "月结", value: 1 }
    ];
    this.parentData.txStatusOptions = [
      { label: "未上链", value: 0 },
      { label: "货源单上链", value: 1 },
      { label: "运单创建", value: 2 },
      { label: "运单启运", value: 3 },
      { label: "已上链", value: 4 },
      { label: "运单支付单创建", value: 5 },
      { label: "运单完成", value: 6 },
      { label: "运单关闭", value: 7 }
    ];
    this.findList();
    // this.openMaYiBlockChain = dataBranch.partyGroupConfigCacheMap.MaYiBlockChainConfig_useMaYiCredit ? dataBranch.partyGroupConfigCacheMap.MaYiBlockChainConfig_useMaYiCredit.configValue == 1 : false;
    this.transport_search_button = getLimit("transport_search_button");
    this.transport_export_button = getLimit("transport_export_button");
    this.transport_detail_button = getLimit("transport_detail_button");
    this.transport_splitOrder_button = getLimit("transport_splitOrder_button");
    this.transport_history_button = true; // getLimit('transport_history_button')
    this.getMaYiOpen();
  },
  methods: {
    clearFilterTable() {
      const pageSize = this.listQuery.pageSize;
      this.listQuery = {
        ...createClearedListQuery(),
        pageNum: 1,
        pageSize,
        sortField: "",
        sortType: "",
        total: 0
      };
      this.consignorAreaList = [];
      this.consigneeAreaList = [];
      if (this.$refs.xTable) {
        this.$refs.xTable.clearSort();
      }
      this.findList();
    },
    watchAppealOrder(obj) {
      this.alertType = "detail";
      this.isAppealOrder = true;
      this.appealInfo = obj;
    },
    pushWaybillToMqttByOrderCodeApi(code, row) {
      this.$confirm("请确认是否重推地磅?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          pushWaybillToMqttByOrderCode({
            orderCode: code
          }).then(response => {
            this.$message({
              type: "success",
              message: response.msg
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    confirmBatchInput(parsedOrderCodes) {
      if (parsedOrderCodes.length > 300) {
        this.$message.warning("运单号数量不能超过300个");
        return;
      }
      this.listQuery.orderCode = parsedOrderCodes.join(",");
      this.batchInputDialogVisible = false;
      this.funcFilter();
    },
    positionFunc(row, form) {
      const source = form || (row && typeof row === "object" ? row : {}) || {};
      this.positoinInfo = {
        vehicleLicense: source.vehicleLicense || source.licenseNumber || "",
        fillTime: source.fillTime || "",
        signTime: source.signTime || ""
      };
      this.code4OrderTrack = row && typeof row === "object" ? row.code : row;
      this.positionFlag = true;
      // this.$nextTick(() => {
      // this.$refs.positionRef.init(row.code, "waitTransport");
      // });
    },
    recoverDeletedOrderApi(row) {
      recoverDeletedOrder({
        code: row.code
      })
        .then(response => {
          this.$message({
            type: "success",
            message: response.msg
          });
          this.findList();
        })
        .catch(call => {
          this.$message({
            type: "error",
            message: call.msg
          });
        });
    },
    copyText(text) {
      if (!text) return;
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message({
        message: "复制成功",
        type: "success",
        duration: 1500
      });
    },
    formatterUnloadingConfirm(scope) {
      let valueCell = scope.row[scope.column.property];
      let data = valueCell == 0;
      return data ? "未签收" : "已签收";
    },
    formatteFeePractical(scope) {
      if (scope.column.property === "deliveryFeePractical") {
        return scope.row.deliveryFeePractical || scope.row.deliveryFeeDeserved;
      }
    },
    formatterPrice(scope) {
      // scope.column.property  scope.row.shipmentDeliveryFeePractical || scope.row.taxFee
      if (scope.column.property === "shipmentDeliveryFeePractical") {
        return scope.row.shipmentDeliveryFeePractical || scope.row.taxFee;
      }
    },
    handleDelete(row) {
      this.showDelete = true;
      this.platformCancelReason = "";
      this.deleteCode = row.code;
    },
    delFunc(row) {
      if (!this.platformCancelReason) {
        this.$message({
          type: "warning",
          message: "请输入取消原因"
        });
        return;
      }
      this.$confirm("请确认是否删除运单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const rLoading = this.openLoading();
          //setTimeout(() => {
          deleteDetail({
            codes: this.deleteCode,
            platformCancelReason: this.platformCancelReason
          })
            .then(response => {
              this.showDelete = false;
              this.$message({
                type: "success",
                message: response.msg
              });
              this.findList();
              rLoading.close();
            })
            .catch(call => {
              rLoading.close();
            });
          //}, 1000000);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    rowClassName({ row, rowIndex }) {
      if (row.isCancel == 4) {
        return "row-grey";
      }
    },
    // add by JiaYK start 2021/10/23 13:19 区块链是否开启显示隐藏上链字段
    getMaYiOpen() {
      isOpenMaYi({ branchCode: this.$store.state.user.party.branchCode }).then(
        res => {
          this.isShowTxStatus = res.data;
        }
      );
    },
    // add by JiaYK end 2021/10/23 13:19 区块链是否开启显示隐藏上链字段
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        let data = {
          ...this.listQuery
        };
        if (this.listQuery.isCancel == 0) {
          data.deleted = 0;
        }
        if (data.deleted === 1) {
          delete data.isCancel;
        }
        // 只搜索撤单申请的
        if (this.listQuery.isCancel == 4) {
          data.deleted = 1;
          delete data.isCancel;
        }
        delete data.gmtCreated;

        console.log("查询参数=====", data);
        let api = this.$route.path.includes("sub_Transport")
          ? querySubList
          : orderDetailList;
        api(data).then(response => {
          this.tableData = response.data.records;
          this.tableData.forEach(item => {
            item.price = item.price + item.isTrunkName;
            item.taxPrice = item.taxPrice + item.isTrunkName;
            item.realPrice = item.realPrice + item.isTrunkName;
            item.coalPrice =
              item.coalPrice === 0
                ? null
                : item.coalPrice + "元/" + item.coalUnitName;
            item.maxPrice = item.maxPrice + item.isTrunkName;
            item.weight = item.weight + item.coalUnitName;
          });
          this.listQuery.total = response.data.total;
          response.data.total > 10000
            ? (this.Pagingconf = [20, 30, 50, 100, 10000])
            : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
          this.sumObject = response.data.sumObject;
          this.loading = false;
          console.log(response.data.records);
          this.$forceUpdate();
          resolve();
        });
      });
    },
    orderDesil(c, item) {
      this.$refs.detailRef.Getdetails(c, true);
      this.tuteship = true;
      this.orderInfo = item;
    },
    //分单
    splitOrder(row) {
      this.$refs.splitOrderRef.findList(row);
      this.splitOrderFlag = true;
    },
    // 装货/收货地址
    changeAreaList(value, prefix) {
      if (value.length > 0) {
        this.listQuery[`${prefix}SubdivisionCode`] = value[2];
      } else {
        this.listQuery[`${prefix}SubdivisionCode`] = "";
      }
    },
    // 类型
    handleChangeCoalType(value) {
      if (value.length > 0) {
        var newValue = value.slice(0);
        this.listQuery.coalType = newValue.pop();
      } else {
        this.listQuery.coalType = "";
      }
    },
    formatterField({ cellValue }, prefix) {
      const options = this.parentData[`${prefix}Options`];
      if (!options || !Array.isArray(options)) {
        return "";
      }
      const item = options.find(item1 => item1.value === cellValue);
      return item ? item.label : "";
    },
    // 取消状态翻译
    formatterCancel(row) {
      // console.log("取消状态翻译==", row.deleted, cellValue);
      let cellValue = row.isCancel;
      let name;
      const item = this.cancelOptions.find(item => item.value === cellValue);
      if (row.deleted === 1) {
        name = "已取消";
      } else {
        name = item ? item.label : "";
      }
      return name;
    },
    formatterETCStatus({ cellValue }) {
      if (!this.etcOptions || !Array.isArray(this.etcOptions)) {
        return "";
      }
      const item = this.etcOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 支付状态翻译
    formatterPayStatus({ cellValue }) {
      if (!this.payOptions || !Array.isArray(this.payOptions)) {
        return "";
      }
      const item = this.payOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 托运人支付状态翻译
    formatterApplyStatus({ cellValue }) {
      if (!this.payShipment || !Array.isArray(this.payShipment)) {
        return "";
      }
      const item = this.payShipment.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译状态
    formatterStatuss({ cellValue }) {
      if (!this.statusOptions || !Array.isArray(this.statusOptions)) {
        return "";
      }
      const item = this.statusOptions.find(item1 => item1.value === cellValue);
      return item ? item.label : "";
    },
    //状态翻译
    formatterStatus({ cellValue }) {
      switch (cellValue) {
        case "0":
          return "未收取";
        case "1":
          return "已收取";
        default:
          return "";
      }
    },
    // 翻译状态
    formatterisTransferSearch({ cellValue }) {
      const item = this.statusOptions.find(item1 => item1.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      if (!this.branchList || !Array.isArray(this.branchList)) {
        return "";
      }
      const item = this.branchList.find(item1 => item1.code === cellValue);
      return item ? item.groupName : "";
    },
    moneyHistoury(c) {
      this.$refs.HistoryRef.show(c);
    },
    setreportMark(reportMarkMsg, code, staus) {
      let option = {};
      if (reportMarkMsg === undefined) {
        reportMarkMsg = "";
        option = {};
      } else {
        option = {
          inputValue: reportMarkMsg
        };
      }
      let message = staus === "0" ? "是否取消该运单上报标记？" : "是否标记？";
      this.$prompt("标记原因", message, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        inputErrorMessage: "标记原因不能为空",
        inputPattern: /\S/,
        ...option
      })
        .then(res => {
          // 确定
          const rLoading = this.openLoading();
          reportMark({
            code: code,
            reportMarkMsg: res.value,
            reportMark: staus
          }).then(response => {
            rLoading.close();
            this.$message.success(response.msg);
            this.findList();
          });
        })
        .catch(value => {
          // 取消
        });
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          // console.log("column.property===================", column, data);
          if (
            [
              "shipmentActualFreight",
              "platformPrepayment",
              "driverActualFreight",
              "driverActualCash",
              "shipmentActualCash",
              "abnormalFee"
            ].includes(column.property)
          ) {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "deliveryFeePractical") {
            return this.$XEUtils.sum(
              data,
              item => item.deliveryFeePractical || item.deliveryFeeDeserved || 0
            );
          }
          if (column.property === "shipmentDeliveryFeePractical") {
            return this.$XEUtils.sum(
              data,
              item => item.shipmentDeliveryFeePractical || item.taxFee || 0
            );
          }
          if (column.property === "shipperDeliveryFee") {
            return this.sumObject.shipperDeliveryFee;
          }
          if (column.property === "taxFee") {
            return this.sumObject.taxFee;
          }
          if (column.property === "payTaxAmount") {
            return this.sumObject.payTaxAmount;
          }
          if (column.property === "extraFee") {
            return this.sumObject.extraFee;
          }
          if (column.property === "payOil") {
            return this.sumObject.payOil;
          }
          if (column.property === "payAmount") {
            return this.sumObject.payAmount;
          }
          if (column.property === "allotOil") {
            return this.sumObject.allotOil;
          }
          if (column.property === "deliveryFeeDeserved") {
            return this.sumObject.deliveryFeeDeserved;
          }
          if (column.property === "deliveryCashFee") {
            return this.sumObject.deliveryCashFee;
          }
          if (column.property === "taxPayFee") {
            return this.sumObject.taxPayFee;
          }
          if (column.property === "distance") {
            return this.sumObject.distance;
          }
          if (column.property === "deliveryOilFee") {
            return this.sumObject.deliveryOilFee;
          }
          if (column.property === "weight") {
            return (
              this.sumObject.ton +
              "吨//" +
              this.sumObject.cubicMeter +
              "方//" +
              this.sumObject.pieces +
              "件"
            );
          }
          if (column.property === "loadQuantity") {
            return (
              this.sumObject.loadQuantityTon +
              "吨//" +
              this.sumObject.loadQuantityCubicMeter +
              "方//" +
              this.sumObject.loadQuantityPieces +
              "件"
            );
          }
          if (column.property === "unloadQuantity") {
            return (
              this.sumObject.unloadQuantityTon +
              "吨//" +
              this.sumObject.unloadQuantityCubicMeter +
              "方//" +
              this.sumObject.unloadQuantityPieces +
              "件"
            );
          }
          if (column.property === "settlementWeight") {
            return (
              this.sumObject.settlementWeightTon +
              "吨//" +
              this.sumObject.settlementWeightCubicMeter +
              "方//" +
              this.sumObject.settlementWeightPieces +
              "件"
            );
          }
          if (column.property === "wastage") {
            return (
              this.sumObject.wastageTon +
              "吨//" +
              this.sumObject.wastageCubicMeter +
              "方//" +
              this.sumObject.wastagePieces +
              "件"
            );
          }
          return "-";
        })
      ];
    }
  }
};
</script>
<style>
.mytable-style .vxe-body--row.row-grey {
  background-color: rgb(216, 216, 216);
  color: rgb(194, 194, 194);
}
.vxe-button {
  margin-left: 0;
}
</style>
<style scoped>
.abnormal_text {
  border-radius: 20px;
  color: red;
  border: 1px solid red;
  text-align: center;
  padding: 0px 5px;
  margin-left: 7px;
}
.yu_text {
  border-radius: 20px;
  color: green;
  border: 1px solid green;
  text-align: center;
  padding: 0px 5px;
  margin-left: 7px;
}
.project_name_span {
  white-space: pre-wrap;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}
.oeder_num_box {
  position: relative;
  display: flex;
  align-items: center;
}
.icon_yu {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 20px;
  height: 20px;
}
::v-deep .vxe-table--footer-wrapper.body--wrapper::-webkit-scrollbar {
  -webkit-appearance: none; /* 禁用默认样式 */
  height: 12px !important; /* 设置滚动条高度（常驻显示） */
  background-color: #f1f1f1; /* 轨道背景色 */
}
::v-deep .vxe-table--footer-wrapper.body--wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important; /* 滑块颜色 */
  border-radius: 5px !important; /* 滑块圆角 */
}
/* 针对微信浏览器定制滚动条 */
::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar {
  -webkit-appearance: none; /* 禁用默认样式 */
  height: 12px !important; /* 设置滚动条高度（常驻显示） */
  background-color: #f1f1f1; /* 轨道背景色 */
}

::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important; /* 滑块颜色 */
  border-radius: 5px !important; /* 滑块圆角 */
}
.green_text {
  width: 70px;
  height: 25px;
  border: 1px solid rgb(4, 204, 4);
  color: rgb(4, 204, 4);
  background: rgba(4, 204, 4, 0.1);
  border-radius: 5px;
  text-align: center;
  line-height: 25px;
  margin: 0 auto;
}
.gray_text {
  width: 70px;
  height: 25px;
  border: 1px solid rgb(193, 190, 190);
  color: rgb(193, 190, 190);
  background: rgb(193, 190, 190, 0.1);
  border-radius: 5px;
  text-align: center;
  line-height: 25px;
  margin: 0 auto;
  padding: 0px 3px;
}
</style>
